import { Plugin } from 'tiptap';
import { Image } from 'tiptap-extensions';
import FileService from '../../services/file-service';
import { API_URL } from '../../../config/config';

export default class ImagePaste extends Image {
	constructor(options = {}) {
		super(options);
		this.options = options;
	}

	get plugins() {
		return [
			new Plugin({
				props: {
					handleDOMEvents: {
						drop: (view, event) => {
							const hasFiles = event.dataTransfer
								&& event.dataTransfer.files
								&& event.dataTransfer.files.length;

							if (!hasFiles) {
								return;
							}
							const images = Array
								.from(event.dataTransfer.files)
								.filter(file => (/image/i).test(file.type));

							if (images.length === 0) {
								return;
							}

							event.preventDefault();

							const coordinates = view.posAtCoords({ left: event.clientX, top: event.clientY });

							images.forEach(image => {
								this.uploadImage(image, view, coordinates);
							})
						},
						paste: (view, event) => {
							let hasFiles = false;

							Array.from(event.clipboardData.files)
								.filter(item => item.type.startsWith("image"))
								.forEach(image => {
									this.uploadImage(image, view);
									hasFiles = true;
								});

							//clean up
							if (hasFiles) {
								event.preventDefault();
								return true;
							}
						}
					},
					handleClick: (view, pos, event) => {
						this.options.clickHandler(event);
					}
				},
			}),
		]
	}

	uploadImage(image, view, coordinates) {
		let tr = view.state.tr;
		FileService.instance().uploadFile(image)
			.then((res) => {
				if (!res.data && !res.data.id) return;

				let imageUrl = API_URL + '/public/file/download/' + res.data.id;

				const node = view.state.schema.nodes.image.create({ src: imageUrl });

				if (coordinates) {
					tr.insert(coordinates.pos, node);
				} else {
					tr.replaceSelectionWith(node);
				}

				view.dispatch(tr);
			}).catch((err) => {
				console.log(err);
			});
	}

}